/**
 * Oprávnění podle role uživatele.
 * Určuje, které cesty (stránky) jsou dostupné pro danou roli.
 *
 * Přehled přístupů:
 * - facilityManager: plný přístup (dashboard, aktiva, WO, RvR, závady, BOZP) + report pro vedení
 * - management: plný přístup + report pro vedení
 * - maintenanceTechnician: dashboard, aktiva, WO, závady (bez RvR a BOZP), bez reportu
 * - safetyOfficer: dashboard, aktiva, WO, závady, BOZP (bez RvR), bez reportu
 */

export const ROUTES = {
  DASHBOARD: '/dashboard',
  ASSETS: '/assets',
  WORK_ORDERS: '/work-orders',
  REPAIR_VS_REPLACE: '/repair-vs-replace',
  FAULT_REPORT: '/fault-report',
  BOZP: '/bozp',
  PREDICTIVE: '/predictive',
};

const ROLE_PATHS = {
  facilityManager: [ROUTES.DASHBOARD, ROUTES.ASSETS, ROUTES.WORK_ORDERS, ROUTES.REPAIR_VS_REPLACE, ROUTES.FAULT_REPORT, ROUTES.BOZP, ROUTES.PREDICTIVE],
  management: [ROUTES.DASHBOARD, ROUTES.ASSETS, ROUTES.WORK_ORDERS, ROUTES.REPAIR_VS_REPLACE, ROUTES.FAULT_REPORT, ROUTES.BOZP, ROUTES.PREDICTIVE],
  maintenanceTechnician: [ROUTES.DASHBOARD, ROUTES.ASSETS, ROUTES.WORK_ORDERS, ROUTES.FAULT_REPORT, ROUTES.PREDICTIVE],
  safetyOfficer: [ROUTES.DASHBOARD, ROUTES.ASSETS, ROUTES.WORK_ORDERS, ROUTES.FAULT_REPORT, ROUTES.BOZP, ROUTES.PREDICTIVE],
};

/**
 * Vrátí seznam povolených cest pro roli.
 * @param {string} role - role uživatele
 * @returns {string[]}
 */
export const getAllowedPaths = (role) => {
  if (!role) return [];
  return ROLE_PATHS[role] ?? [ROUTES.DASHBOARD];
};

/**
 * Ověří, zda má role přístup na danou cestu.
 * @param {string} role - role uživatele
 * @param {string} pathname - cesta (např. /work-orders)
 * @returns {boolean}
 */
export const canAccess = (role, pathname) => {
  const normalized = pathname?.replace(/\/$/, '') || '/';
  const allowed = getAllowedPaths(role);
  if (normalized === '' || normalized === '/') return allowed.includes(ROUTES.DASHBOARD);
  return allowed.some((p) => normalized === p || normalized.startsWith(p + '/'));
};

/** Report pro vedení – pouze pro facility managera a management. */
export const canViewManagementReport = (role) => {
  return role === 'facilityManager' || role === 'management';
};
